import { get, post } from "app/apis";
import CarRoutes from "./CarRoutes";

const CarService = {
  getCarBooking: async () => {
    const data = await get(CarRoutes.getCarBooking);
    return data;
  },
  createCarBooking: async (obj) => {
    const data = await post(CarRoutes.createCarBooking, obj);
    return data;
  },
  deleteCarBooking: async (obj) => {
    const data = await post(CarRoutes.deleteCarBooking, obj);
    return data;
  },
  getCarService: async () => {
    const data = await get(CarRoutes.getCarService);
    return data;
  },
  updateCarService: async (obj) => {
    const data = await post(CarRoutes.updateCarService, obj);
    return data;
  },
  assignDriver: async (obj) => {
    const data = await post(CarRoutes.assignDriver, obj);
    return data;
  },
  deleteCarService: async (obj) => {
    const data = await post(CarRoutes.deleteCarService, obj);
    return data;
  },
};

export default CarService;
